var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}.cls-1,.cls-2,.cls-3{fill:none;}.cls-2{stroke:#e8ba3a;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-4{clip-path:url(#clippath);}.cls-3{stroke:#193c34;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.81,
    y: 1.71,
    width: 236.39,
    height: 146.58
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.45,
    y1: 141.36,
    x2: 228.55,
    y2: 141.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.14,102.97h0c1.48,0,2.83-.87,3.42-2.23,2.01-4.66,6.65-7.93,12.05-7.93h62.72c5.4,0,10.04,3.26,12.05,7.93.59,1.36,1.94,2.23,3.42,2.23h0c1.53,0,2.87,1.12,3.03,2.63.19,1.79-1.2,3.3-2.95,3.3h-.08c-1.48,0-2.83.87-3.42,2.23-2.01,4.66-6.65,7.93-12.05,7.93h-62.72c-5.4,0-10.04-3.26-12.05-7.93-.59-1.36-1.94-2.23-3.42-2.23h-.08c-1.69,0-3.04-1.41-2.96-3.11.08-1.6,1.45-2.82,3.05-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.14,76.72h0c1.48,0,2.83-.87,3.42-2.23,2.01-4.66,6.65-7.93,12.05-7.93h62.72c5.4,0,10.04,3.26,12.05,7.93.59,1.36,1.94,2.23,3.42,2.23h0c1.53,0,2.87,1.12,3.03,2.63.19,1.79-1.2,3.3-2.95,3.3h-.08c-1.48,0-2.83.87-3.42,2.23-2.01,4.66-6.65,7.93-12.05,7.93h-62.72c-5.4,0-10.04-3.26-12.05-7.93-.59-1.36-1.94-2.23-3.42-2.23h-.08c-1.69,0-3.04-1.41-2.96-3.11.08-1.6,1.45-2.82,3.05-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m126.88,56.4h-.08c-1.48,0-2.83.87-3.42,2.23-2.01,4.66-6.65,7.93-12.05,7.93h-62.72c-5.4,0-10.04-3.26-12.05-7.93-.59-1.36-1.94-2.23-3.42-2.23h-.08c-1.69,0-3.04-1.41-2.96-3.11.08-1.6,1.45-2.82,3.05-2.82,1.48,0,2.83-.87,3.42-2.23,2.01-4.66,6.65-7.93,12.05-7.93h62.72c5.4,0,10.04,3.26,12.05,7.93.59,1.36,1.94,2.23,3.42,2.23.76,0,1.48.28,2.03.75.55.47.92,1.13,1.01,1.89.19,1.79-1.2,3.3-2.95,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m111.33,119.06h-62.72c-5.4,0-10.04-3.26-12.05-7.92-.59-1.36-1.94-2.24-3.42-2.24h-.08c-1.69,0-3.04-1.41-2.96-3.11.07-1.6,1.45-2.82,3.05-2.82,1.48,0,2.83-.87,3.42-2.23,2.01-4.66,6.65-7.93,12.05-7.93h31.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m81.51,66.56h-32.9c-5.4,0-10.04,3.26-12.05,7.93-.59,1.36-1.94,2.23-3.42,2.23-1.6,0-2.97,1.23-3.05,2.82-.08,1.7,1.28,3.11,2.96,3.11h.08c1.48,0,2.83.87,3.42,2.23,2.01,4.66,6.65,7.93,12.05,7.93h31.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.17,41.08c1.39-.5,2.88-.77,4.44-.77h28.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.76,46.05c-.47.68-.87,1.41-1.2,2.18-.59,1.36-1.94,2.23-3.42,2.23-1.6,0-2.97,1.23-3.05,2.82-.08,1.7,1.28,3.11,2.96,3.11h.08c1.48,0,2.83.87,3.42,2.23,2.01,4.66,6.65,7.93,12.05,7.93h32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m130.41,132.05H29.53c-1.7,0-3.08-1.38-3.08-3.08v-4.61c0-1.7,1.38-3.08,3.08-3.08h100.89c1.7,0,3.08,1.38,3.08,3.08v4.61c0,1.7-1.38,3.08-3.08,3.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.08,
    y: 132.05,
    width: 16.76,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.03,
    y: 132.05,
    width: 16.76,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m165.9,13.52l5.8-3.63c3.2-2,7.28-1.96,10.43.12l5.01,3.3c1.14.75,2.43,1.25,3.77,1.47l6.95,1.12c3.89.63,7.01,3.55,7.88,7.39l.96,4.23c.39,1.72,1.24,3.29,2.46,4.56l4.3,4.46c2.68,2.78,3.45,6.89,1.95,10.45l-2.26,5.35c-.59,1.39-.84,2.9-.74,4.4l.36,5.28c.25,3.65-1.58,7.12-4.73,8.97l-5.16,3.04c-1.06.62-1.98,1.44-2.73,2.41l-4.1,5.3c-2.14,2.76-5.61,4.16-9.07,3.64l-8.19-1.23c-1.22-.18-2.46-.13-3.66.15l-5.91,1.4c-3.38.8-6.92-.27-9.29-2.81l-6.29-6.74c-.57-.61-1.22-1.15-1.93-1.6l-6.31-3.95c-3.35-2.1-5.09-6.04-4.37-9.93l.61-3.32c.36-1.98.1-4.02-.75-5.84l-2.02-4.32c-1.56-3.33-1.1-7.25,1.19-10.12l3.26-4.09c.61-.77,1.11-1.63,1.46-2.55l3.11-8.07c1.18-3.07,3.85-5.32,7.07-5.99l7.77-1.59c1.13-.23,2.21-.66,3.18-1.27Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 177.07,
    cy: 47.19,
    r: 26.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "163.25 50.47 170.49 57.26 190.83 38.57"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo02);
export default __webpack_public_path__ + "static/media/logo02.0536f63c6cd6ab80778db5aea13bf0f8.svg";
export { ForwardRef as ReactComponent };